import React, { useState, useContext } from "react";
import UpdateInvoice from '../components/Invoices/UpdateInvoice';
import AddInvoice from '../components/Invoices/AddInvoice';
import AuthContext from "../AuthContext";
import AllInvoice from '../components/Invoices/AllInvoice';

function Inventory() {
  const [showProductModal, setShowProductModal] = useState(false);
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [updateProduct, setUpdateProduct] = useState([]);
  const [updatePage, setUpdatePage] = useState(true);

  const authContext = useContext(AuthContext);

  // Toggle Add Invoice Modal
  const addProductModalSetting = () => {
    setShowProductModal(!showProductModal);
  };

  // Toggle Update Invoice Modal
  const updateProductModalSetting = (selectedProductData) => {
 
    setUpdateProduct(selectedProductData);
    setShowUpdateModal(!showUpdateModal);
  };

  // Handle Page Update
  const handlePageUpdate = () => {
    setUpdatePage(!updatePage);
  };

  return (
    <div className="col-span-12 lg:col-span-10 flex justify-center">
      <div className="flex flex-col gap-5 w-11/12">

        {/* Add Invoice Modal */}
        {(authContext.userType === 'Superadmin' || authContext.userType==="Accounts") && showProductModal && (
          <AddInvoice
            addProductModalSetting={addProductModalSetting}
            handlePageUpdate={handlePageUpdate}
          />
        )}

        {/* Update Invoice Modal */}
        {showUpdateModal && (
          <UpdateInvoice
            updateProductData={updateProduct}
            updateModalSetting={updateProductModalSetting}
            handlePageUpdate={handlePageUpdate}
          />
        )}

        {/* Table */}
        <div className="overflow-x-auto rounded-md bg-white border border-gray-200 shadow-lg">
          <div className="flex justify-between p-4 bg-gray-100 border-b border-gray-200">
            <h2 className="font-bold text-lg text-gray-700">Invoice</h2>
            {(authContext.userType === 'Superadmin' || authContext.userType==="Accounts") && (
              <div className="flex gap-4">
                <button
                  className="bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-4 text-sm rounded-sm shadow-md transition duration-300"
                  onClick={addProductModalSetting}
                >
                  Add Invoice
                </button>
              </div>
            )}
          </div>
          <AllInvoice
            updateProductModalSetting={updateProductModalSetting}
            handlePageUpdate={handlePageUpdate}
          />
        </div>
      </div>
    </div>
  );
}

export default Inventory;
